import { PaymentsProps } from '../icon-types';
import { SvgWrapper } from '../svg-wrapper/payment-wrapper';

export function AmexIcon(props: PaymentsProps) {
  return (
    <SvgWrapper {...props}>
      <g fill="none" fillRule="evenodd">
        <rect
          x={0.5}
          y={0.5}
          width={35}
          height={23}
          rx={4}
          fill="#FFF"
          stroke="#CFD4D9"
        />
        <path
          d="M8.709 9 6 14.992h3.243l.402-.955h.918l.402.955h3.57v-.729l.318.73h1.846l.318-.745v.744h7.423l.902-.93.845.93L30 15l-2.717-2.987L30 9h-3.753l-.879.913L24.549 9h-8.075l-.693 1.547L15.07 9h-3.236v.704L11.475 9H8.71Zm.603.844h1.586l1.803 4.075V9.844h1.738l1.392 2.922 1.284-2.922h1.729v4.312h-1.052l-.009-3.379-1.533 3.38h-.942l-1.542-3.38v3.38h-2.164l-.41-.968H8.975l-.41.966H7.407l1.906-4.311Zm10.47 0h4.28l1.309 1.413 1.351-1.413h1.31l-1.99 2.168 1.99 2.144h-1.37l-1.308-1.429-1.359 1.43h-4.214V9.843Zm-9.657.75-.75 1.687h1.5l-.75-1.687Zm10.688.094v.79h2.34v.88h-2.34v.86h2.624l1.22-1.268-1.168-1.262h-2.677Z"
          fill="#006FD0"
          fillRule="nonzero"
        />
      </g>
    </SvgWrapper>
  );
}
